import React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { MzRadioGroup, MzRadio } from "@markaaz/ui/MzRadioControls";
import MzInput from "@markaaz/ui/MzInputControls";
import MzAlert from "@markaaz/ui/MzAlert";
const sx = {
  radio: {
    paddingLeft: "20px",
    "& .MuiButtonBase-root.MuiRadio-root": {
      color: (theme) => theme.palette.darkBlue.c50
    },
    "& .MuiButtonBase-root.MuiRadio-root.Mui-checked": {
      color: (theme) => theme.palette.blue.c100
    }
  }
};

function MySFTPRadio({ show, outputFolder, folderError, onOutputFolder }) {
  return (
    <>
      {show === "sftpOutputFolder" && (
        <Box sx={{ paddingLeft: "50px" }}>
          <Typography variant="body2" mt={4} mb={2}>
            Help us find your file by typing the folder name where the file will be placed. Indicate sub folders with
            slash marks. If it’s the root folder, you can leave this blank.
          </Typography>
          <MzInput
            placeholder="ex: SFTP/Batch/September"
            label="Folder Name"
            value={outputFolder}
            onChange={onOutputFolder}
            fullWidth
            error={!outputFolder || folderError}
            helperText={
              !outputFolder ? "Folder name cannot be empty." : folderError ? "Folder name cannot be same." : null
            }
          ></MzInput>
        </Box>
      )}
    </>
  );
}

function FilePlacementConfiguration({
  onBatchPlacement,
  batchPlacement,
  permissions,
  outputFolder,
  folderError,
  onOutputFolder,
  showAlert,
  onDisabledSection,
  onAlertClose
}) {
  return (
    <Box>
      <Box p={5}>
        <Typography variant="body1M" color="blue.c100">
          Completed Batch File Placement
        </Typography>
        <Typography variant="body2" mt={1} mb={4}>
          Select where to place completed batch files.
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Stack onClick={!permissions.partnerHostedSFTP ? () => onDisabledSection("filePlacementSftp") : null}>
            <MzRadioGroup name="batchFilePlacement" sx={sx.radio} onChange={onBatchPlacement} value={batchPlacement}>
              <MzRadio value="mySftpBatchPlacement" label="Markaaz’s SFTP Output Folder" />
              <MzRadio value="sftpOutputFolder" disabled={!permissions.partnerHostedSFTP} label="My SFTP" />
            </MzRadioGroup>
          </Stack>
          {showAlert.filePlacementSftp && (
            <MzAlert
              severity={"error"}
              sx={{ maxWidth: "352px", maxHeight: "40px", alignItems: "center", marginTop: "30px" }}
              onClose={() => {
                onAlertClose("filePlacementSftp");
              }}
            >
              Batch configuration not found
            </MzAlert>
          )}
        </Box>
        <MySFTPRadio
          show={batchPlacement}
          folderError={folderError}
          outputFolder={outputFolder}
          onOutputFolder={onOutputFolder}
        />
      </Box>
    </Box>
  );
}

export default FilePlacementConfiguration;
